import React, { useState, useEffect } from "react";
import { BASE_URL } from './apiConfig';
import Swal from 'sweetalert2';
import { RotateSpinner } from "react-spinners-kit";
import { useNavigate } from 'react-router-dom';

export default function AlreadyWhitelistkeyandip() {

    const [Apidata, setAPIData] = useState([]);
    const [guiuser, setguiuser] = useState('');
    const [distinctuser, setdistinctuser] = useState([]); 
    const [seller, setseller] = useState('');
    const [distinctSeller, setdistinctSeller] = useState([]);
    const [showprogress, setshowprogress] = useState(false);
    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;
    const [DistinctAPIData, setDistinctAPIData] = useState([]);
    const [apikeyvalue, setapikeyvalue] = useState('');
    const [guirowuser, setguirowuser] = useState('');
    const [apirowuser, setapirowuser] = useState('');
    const [rowapikey, setrowapikey] = useState('');
    const [rowipvalue, setrowipvalue] = useState([]);
    const [rowipcheck, setrowipcheck] = useState('');
    const [load, setload] = useState(false);

    const navigate = useNavigate();

    const handleCheckboxChange = () => {
        setrowipcheck((prev) => (prev === "1" ? "0" : "1")); // toggle between "1" and "0"
    };

    // IP Address validation regex
    const ipPattern = /^(?:(?:\d{1,3})\.){3}(?:\d{1,3})$/;

    // This function will handle the change in the IP input
    const handleIpChange = (index, newIp) => {
        // Split the IP by dots (.)
        const parts = newIp.split('.');

        // Remove leading zeros from each part of the IP address, except if the part is "0"
        for (let i = 0; i < parts.length; i++) {
            parts[i] = parts[i] === "0" ? "0" : parseInt(parts[i], 10).toString();
        }

        // Join the parts back together
        const updatedIp = parts.join('.');

        // Validate the updated IP and ensure it's not a duplicate
        if (
            updatedIp === "" || // Allow clearing the IP value
            (ipPattern.test(updatedIp) && !rowipvalue.includes(updatedIp)) // Validate if the new IP is unique and valid
        ) {
            const updatedIps = [...rowipvalue];
            updatedIps[index] = updatedIp;  // Update the IP at the specific index

            setrowipvalue(updatedIps);
        } else {
            // If invalid or duplicate IP, you can show an alert or handle the error as you see fit
            console.log("Invalid IP or duplicate IP address.");
        }
    };

    // Function to handle IP deletion
    const handleDeleteIp = (index) => {
        const updatedIps = rowipvalue.filter((_, i) => i !== index); // Remove the IP at the given index
        setrowipvalue(updatedIps);
    };


    const handlemodalclose = () => {
        // Close the modal by triggering the click event
        document.getElementById('closeModalButton2').click();

        // Delay the navigation to ensure the modal is fully closed
        setTimeout(() => {
            navigate('/newipwhitelist');
        }, 100); // Adjust the timeout if needed (in milliseconds)
    };


    const handleRowClick = (index) => {
        const prts = Apidata[index]?.guiuserid.split('#')
        setguirowuser(prts[0]);
        setapirowuser(prts[1])
        setrowapikey(Apidata[index]?.skey?.genertaedSkey);
        setrowipcheck(Apidata[index]?.isiptocheck);
        // Ensure ipmapped exists before splitting
        const ipmapped = Apidata[index]?.ipmapped;


        if (ipmapped) {
            setrowipvalue(ipmapped.split(','));
        } else {
            setrowipvalue([]);
        }

    }

    const callDistinctGUIUser = async () => {
        let usr = "";
        if (seller !== "") {
            usr = seller;
        }

        else {
            usr = sessionusername;
        }
        const apiUrl = `${BASE_URL}/AllUsers?uid=${usr}`;

        const fetchOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };
        setshowprogress(true);
        try {

            const response = await fetch(apiUrl, fetchOptions);
            setshowprogress(false);
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }

            const data = await response.json();

            const filteredData = data.filter(
                (option) => String(option?.utype) === "2"
            );

            const filteredUserData = data.filter(
                (option) => String(option?.utype) === "1"
            );
            console.log(data);

            if (seller === "") {
                setdistinctSeller(filteredData);
                setdistinctuser(filteredUserData);
            }

            else {
                setdistinctuser(filteredUserData);
            }
        } catch (error) {
            setshowprogress(false);
            console.error("API Request Error:", error.message);
        }
    };

    const CallDistinctAPIKey = async () => {

        try {
            setshowprogress(true);
            const apiUrl = `${BASE_URL}/DistinctAPIKey`;
            const requestBody = {
                guiuserid: sessionusertype === 1 ? sessionusername : guiuser,
            };
            const fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(requestBody),
            };

            const response = await fetch(apiUrl, fetchOptions);
            if (!response.ok) {
                setshowprogress(false);
                console.log(`API request failed with status ${response.status}`);
                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: ("Request Failed with Status:" + response.status),
                    icon: 'error'
                });

                if (result.isConfirmed) {
                    setDistinctAPIData([]);
                }
                return;
            }


            // Check if response is not empty before parsing as JSON
            const responseText = await response.text();
            let data;
            if (responseText) {
                data = JSON.parse(responseText);
            } else {
                data = [];
            }

            if (data?.length > 0) {
                setDistinctAPIData(data);
            } else {
                setDistinctAPIData([]);
            }

            setshowprogress(false);
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {

            }
            return;
        }
    };

    const callWhitelistedKeyandIP = async () => {
        try {
            setshowprogress(true);
            // console.log("sessionusername for type 1:" + sessionusername);
            // console.log("guiuser for type 0:" + guiuser);
            // console.log("apikey:" + apikeyvalue)
            setAPIData([]);
            if (!apikeyvalue || (sessionusertype === 1 && !sessionusername) || (sessionusertype === 0 && !guiuser)) {
                setshowprogress(false);
                const re = await Swal.fire({
                    title: "Value Error!",
                    text: "Please Fill in All Fields Values as Either API Key Value or GUI User not inputted",
                    icon: "error"
                })

                if (re.isConfirmed) {
                    setapikeyvalue('');

                }
                return;
            }

            else {

                const apiUrl = `${BASE_URL}/ListAPIKEYandIPWhitelisting`;
                const requestBody = {
                    guiuserid: sessionusertype === 1 ? sessionusername : guiuser,
                    selleruser:seller || sessionusername,
                    requser: guiuser,
                    seckey: {
                        GenertaedSkey: apikeyvalue
                    }
                };
                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(requestBody),
                };

                const response = await fetch(apiUrl, fetchOptions);
                if (!response.ok) {
                    setshowprogress(false);
                    console.log(`API request failed with status ${response.status}`);
                    // const result = await Swal.fire({
                    //     title: 'API Request Error',
                    //     html: ("Request Failed with Status:" + response.status),
                    //     icon: 'error'
                    // });
                    setAPIData([]);
                    setDistinctAPIData([]);
                    setguiuser('');
                }

                else {
                    // Check if response is not empty before parsing as JSON
                    const responseText = await response.text();
                    let data;
                    if (responseText) {
                        data = JSON.parse(responseText);
                    } else {
                        data = [];
                    }

                    if (data?.length > 0) {
                        setAPIData(data);
                    } else {
                        setAPIData([]);
                    }
                    // console.log(data);
                    setshowprogress(false);
                }
            }

        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {
                setAPIData([]);
            }
            return;
        }

    };

    const CallUpdatePWhiteListing = async () => {
        try {
            setload(true);
            const apiUrl = `${BASE_URL}/UpdateWhitelistedIP`;
            const ips = rowipvalue.join(',');
            console.log("IP comma Separeted:" + ips);

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    GenertaedSkey: rowapikey,
                    ipaddress: ips,
                    ipchecking: rowipcheck
                }),
            });

            if (!response.ok) {
                setload(false);
                const errorMessage = response.statusText;
                const responseBody = await response.text();
                setshowprogress(false);
                const result = await Swal.fire({
                    title: 'Update IP Whitelisting Error',
                    html: `${errorMessage}${responseBody}`,
                    icon: 'error'
                });

                if (result.isConfirmed) {
                    document.getElementById('closeModalButton2').click();
                }

            }

            else {
                setload(false);
                const result = await Swal.fire({
                    title: "IP Updated Successfully!",
                    text: `Successfully Updated [ ${ips} ] with API Key "${rowapikey}"`,
                    icon: "success"
                });

                if (result.isConfirmed) {
                    document.getElementById('closeModalButton2').click();
                    callWhitelistedKeyandIP();
                }
            }
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {
                setAPIData([]);
            }
            return;
        }
    };

    useEffect(() => {
        if (sessionusertype !== 1) {
            callDistinctGUIUser();
        }

        else {
            setguiuser(sessionusername);

            CallDistinctAPIKey();
        }

    }, []);

    useEffect(() => {
        if (guiuser !== "" && guiuser !== "All") {
            CallDistinctAPIKey();
        }

        if (guiuser === "All") {
            setapikeyvalue("All");
        }
    }, [guiuser]);

    useEffect(() => {
        if (seller !== "") {
            callDistinctGUIUser();
        }
    }, [seller])

    // const apiDataLength = 1;
    const apiDataLength = Apidata?.length;


    return (
        <div className="maincontent-outermost">
            <div className="div-container" style={{ position: "relative" }}>
                <div className="row-container">
                    <span>Whitelisted API Key and IP</span>
                </div>

                {showprogress && (
                    <div className="spinner-overlay">
                        <div className="custom-spinner"></div>
                    </div>
                )}

                <div className={showprogress === true ? "row-container blurred" : "row-container"}>
                    <div className="flex-div">
                        {sessionusertype === 0 && (
                            <div className="medium-flex-div"  >

                                <label htmlFor="apiuser" >Select Seller</label>
                                {sessionusertype !== 1 ? (
                                    <select
                                        className="selectpicker form-control"
                                        value={seller}
                                        onChange={(e) => setseller(e.target.value)}
                                        style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                    >
                                        <option value="" disabled >Select Seller</option>
                                        {distinctSeller?.map((option, index) => (
                                                <option
                                                    key={index}
                                                    value={option?.guiuserid}
                                                    style={{
                                                        textOverflow: "ellipsis",
                                                        overflowWrap: "break-word",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: "-1rem"
                                                    }}
                                                >
                                                    {option?.guiuserid}
                                                </option>
                                            ))
                                        }
                                    </select>
                                ) : (
                                    <input type="text" className="form-control" value={sessionusername} disabled />
                                )}


                            </div>
                        )}

                        <div className={sessionusertype === 0 ? "medium-flex-div" : "bigger-flex-div"} >

                            <label htmlFor="apiuser" >GUI User ID</label>
                            {sessionusertype !== 1 ? (
                                <select
                                    className="selectpicker form-control"
                                    value={guiuser}
                                    onChange={(e) => setguiuser(e.target.value)}
                                    style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                >
                                    <option value="" disabled >Select User</option>
                                    <option value="All">All</option>
                                    {distinctuser?.map((option, index) => (
                                            <option
                                                key={index}
                                                value={option?.guiuserid}
                                                style={{
                                                    textOverflow: "ellipsis",
                                                    overflowWrap: "break-word",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    marginLeft: "-1rem"
                                                }}
                                            >
                                                {option?.guiuserid}
                                            </option>
                                        ))
                                    }
                                </select>
                            ) : (
                                <input type="text" className="form-control" value={sessionusername} disabled />
                            )}


                        </div>

                        <div className={sessionusertype === 0 ? "medium-flex-div" : "bigger-flex-div"} >

                            <label htmlFor="apiuser" >API Key </label>
                            <select
                                className="selectpicker form-control"
                                value={guiuser === "All" ? "All" : apikeyvalue}
                                onChange={(e) => setapikeyvalue(e.target.value)}
                                style={{
                                    fontSize: "0.8rem",
                                    textOverflow: "ellipsis",
                                    overflowWrap: "break-word",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                }}
                                disabled={guiuser === "All"} // Disable the dropdown if guiuser is "All"
                            >
                                <option value="" disabled>Select API Key</option>
                                <option value="All">All</option>
                                {DistinctAPIData?.map((option, index) => (
                                    <option
                                        key={index}
                                        value={option?.genertaedSkey}
                                        style={{
                                            textOverflow: "ellipsis",
                                            overflowWrap: "break-word",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            marginLeft: "-1rem",
                                        }}
                                    >
                                        {option?.genertaedSkey}
                                    </option>
                                ))}
                            </select>


                        </div>

                        <div style={{ marginTop: "1rem" }} className="btn-div-whitelist">
                            <button type="submit" className="btn btn-info" onClick={callWhitelistedKeyandIP} >Submit
                                <img src="images/tap.png" style={{ width: "1.1rem", height: "1.1rem" }} />
                            </button>
                        </div>
                    </div>
                </div>

                <div className={showprogress === true ? "row-container blurred mt-3 table-responsive" : "row-container mt-3 table-responsive"} style={{ position: "relative" }}>
                    {apiDataLength === 0 ? (
                        <div style={{ display: "flex", width: "100%", justifyContent: "center", marginBottom: "3rem" }}>
                            <div className="img-report-div">
                                <div className="img-div">
                                    <img src="images/NoReport.png" className="img-noreport" alt="No Report" />

                                </div>
                                <p style={{ marginLeft: "0rem", marginTop: "1rem", color: "grey" }}>
                                    No Record Found !!!
                                </p>
                            </div>
                        </div>
                    ) : (
                        <table className="table table-bordered mt-1">
                            <thead style={{ backgroundColor: "skyblue" }}>
                                <tr>
                                    <th>GUI User # API User </th>
                                    <th>API Key</th>
                                    <th>IP Whitelisted</th>
                                    <th>Is IP to Check</th>
                                    {sessionusertype === 1 &&  <th>Action</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {/* Render rows dynamically based on the data */}
                                {Apidata?.map((item, index) => {
                                    const ipArray = item.ipmapped.split(','); // Split the IPs from comma-separated string

                                    // Check if we need to merge the "User ID" column
                                    const isFirstRowForUser = index === 0 || Apidata[index - 1].guiuserid !== item.guiuserid;

                                    return (
                                        <tr key={index}>
                                            {isFirstRowForUser && (
                                                <td rowSpan={Apidata.filter(i => i.guiuserid === item.guiuserid).length}>
                                                    {item?.guiuserid}
                                                </td>
                                            )}
                                            {/* <td>{item.primarykey}</td> Platform API Key */}

                                            <td>{item?.skey?.genertaedSkey}</td> {/* User Generated API Key */}
                                            <td>
                                                <textarea
                                                    style={{
                                                        width: "100%",
                                                        border: "none",
                                                        backgroundColor: "#fff",
                                                        resize: "none",
                                                        color: ipArray.length > 0 && ipArray[0] !== "" ? "" : "red", // Set text color based on IP array condition
                                                        fontWeight: ipArray.length > 0 && ipArray[0] !== "" ? "" : "600",
                                                    }}
                                                    rows={ipArray.length} // Dynamically set the number of rows based on the number of IPs
                                                    disabled
                                                    value={ipArray.length > 0 && ipArray[0] !== "" ? ipArray.join('\n') : "No IP Whitelist Yet."} // Join IPs with newline for textarea
                                                />

                                            </td>
                                            <td>
                                                <span
                                                    style={{
                                                        padding: "0.1rem 0.4rem",
                                                        backgroundColor: item.isiptocheck === "1" ? "greenyellow" : "red",
                                                        fontSize: "0.8rem",
                                                        fontWeight: "400"
                                                    }}
                                                >
                                                    {item.isiptocheck === "1" ? "True" : "False"}
                                                </span>
                                            </td>

                                            {sessionusertype === 1 && (
                                                <td >
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    <button className="btn" style={{ textAlign: "center", backgroundColor: "#00CCCC" }} data-toggle="modal" data-target="#exampleModal" onClick={() => handleRowClick(index)} >Edit
                                                        <i className="fas fa-edit " style={{ fontSize: "1rem", marginLeft: "1rem" }} ></i>
                                                    </button>

                                                </div>
                                            </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}

                   
                </div>

                 <div className="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"   >
                       
                        <div className="modal-dialog modal-dialog-centered modal" role="document">
                            <div className="modal-content" >
                                <div className="modal-header" style={{ backgroundColor: "#2392e0" }}>
                                    <h5 className="modal-title" id="exampleModalLabel">Editing Whitelisted IP Address</h5>
                                    <button type="button" id="closeModalButton2" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <div className={load === true ? "modal-body blurred" : "modal-body"} style={{ padding: "0rem", zIndex:"10000" }} >
                                    <table className="table" style={{ width: "100%", overflowX: "auto", marginBottom: "0rem" }}>
                                        <thead></thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row" style={{ verticalAlign: "middle" }}>GUI User ID</th>
                                                <td>
                                                    <input type="text" className="form-control" value={guirowuser} disabled />
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row" style={{ verticalAlign: "middle" }}>API User ID</th>
                                                <td>
                                                    <input type="text" className="form-control" value={apirowuser} disabled />
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row" style={{ verticalAlign: "middle" }}>API Key</th>
                                                <td>
                                                    <input type="text" className="form-control" value={rowapikey} disabled />
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row" style={{ verticalAlign: "middle" }}>Is IP To Check</th>
                                                <td>
                                                    <div className="checkbox-wrapper-12 mr-2" style={{ display: "flex" }} >
                                                        <div className="cbx" >
                                                            <input
                                                                id="cbx-12"
                                                                type="checkbox"
                                                                checked={rowipcheck === "1"}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                            <label htmlFor="cbx-12"></label>
                                                            <svg width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                                <path d="M2 8.36364L6.23077 12L13 2"></path>
                                                            </svg>

                                                        </div>

                                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                                                            <defs>
                                                                <filter id="goo-12">
                                                                    <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur"></feGaussianBlur>
                                                                    <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 22 -7" result="goo-12"></feColorMatrix>
                                                                    <feBlend in="SourceGraphic" in2="goo-12"></feBlend>
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                        <div className="ml-2" >{rowipcheck === "1" ? "Yes!!! IP to Check" : "No!!! IP not to Check"}</div>

                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row" style={{ verticalAlign: "middle" }}>Mapped IP

                                                    <button onClick={handlemodalclose} className="btn btn-info ml-2" style={{ fontSize: "1rem" }}><i class="fa-solid fa-circle-plus"></i></button>
                                                </th>
                                                <td>
                                                    {rowipvalue.length === 0 ? (
                                                        // If the rowipvalue array is empty, display the message
                                                        <p style={{ verticalAlign: "middle", marginTop: "0.85rem", color: "red", fontWeight: "700" }}>No IP whitelist yet</p>
                                                    ) : (
                                                        // Otherwise, display the input fields and trash icons
                                                        rowipvalue.map((ip, index) => (
                                                            <div key={index} style={{ display: "flex", alignItems: "center" }}>
                                                                <input
                                                                    type="text"
                                                                    value={ip}
                                                                    className="form-control mb-2"
                                                                    onChange={(e) => handleIpChange(index, e.target.value)}
                                                                    placeholder="Enter valid IP address"
                                                                />
                                                                <i
                                                                    className="fa-solid fa-trash"
                                                                    onClick={() => handleDeleteIp(index)}
                                                                    style={{
                                                                        marginBottom: "0.4rem",
                                                                        marginLeft: "0.5rem",
                                                                        cursor: "pointer",
                                                                        color: "red"
                                                                    }}
                                                                ></i>
                                                            </div>
                                                        ))
                                                    )}


                                                </td>


                                            </tr>




                                        </tbody>

                                        <div className="row-container ml-3 mb-3">
                                            <button type="submit" className="btn btn-info " disabled={load === true} onClick={CallUpdatePWhiteListing}>Save Changes</button>
                                            <button type="reset" className="btn btn-danger ml-3" onClick={() => document.getElementById('closeModalButton2').click()} >Cancel</button>
                                        </div>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>


            </div>
        </div>
    );
}